<div class="modal-body">
  <div class="row" style="height: 66vh;">
    <iframe style="border: none;" id="iframeModalWindow" height="100%" width="100%" [src]="transferURL | safe"
      name="iframe_modal"></iframe>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary pull-right" data-dismiss="modal" (click)="closeModal()"
    style="background: #DE1B36 !important; border: 1px red solid; cursor: pointer; color: white; margin-bottom: 10px;">Continue
    Shopping</button>
</div>
